// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"c7276650a0dbf7e3401e","488":"9cd4b6361e986c4f758a","532":"8bbf4a81c065a9b9699d","592":"45071c695e091bd73b16","736":"3505844448ded2ba1d26"}[chunkId] + ".js";
};